import Usuario from "model/administracao/cadastro/Usuario";
import { BaseEditModel } from "model/BaseEditModel";
import CentroCusto from "./CentroCusto";

export default class CentroCustoUsuario implements BaseEditModel {
    id: number;
    key: string | null = "";
    sequencial: number | null = 0;
    centroCusto: CentroCusto;
    usuario: Usuario;
    aprovaViagens: boolean = false;
    consultaViagens: boolean = false;
    recebeEmailParaAprovarViagem: boolean = false;
    constructor(
        id: number = 0,
        centroCusto: CentroCusto = new CentroCusto(),
        usuario: Usuario = new Usuario(),
        aprovaViagens: boolean = false,
        consultaViagens: boolean = false,
        recebeEmailParaAprovarViagem = false
    ) {
        this.id = id;
        this.centroCusto = centroCusto;
        this.usuario = usuario;
        this.aprovaViagens = aprovaViagens;
        this.consultaViagens = consultaViagens;
        this.recebeEmailParaAprovarViagem = recebeEmailParaAprovarViagem;
    }
}
